import jquery from 'jquery';
window.$ = window.jQuery=jquery;

import { ACTION, Events } from './events'
import { VARS } from './vars.js'
import { $DOM } from './selectors'

require ('jquery-query-object')
import '../vendors/bootstrap-datepicker-1.9.0-dist/js/bootstrap-datepicker'
require('../vendors/bootstrap-datepicker-1.9.0-dist/locales/bootstrap-datepicker.pl.min');

import './modules/banner'
import './modules/floatingBox'
import './modules/contactForm'
import './modules/homePageAnimation'
import './modules/sectorsProducts'
import './modules/glossaryListing'
import './modules/homePageHeader'
import './modules/headerNav'
import './modules/sideMenuProducts'
import './modules/logotypesCarousel'
import './modules/buttonShare'
import './modules/tagSearch'
import './modules/cookieGate'
import './modules/personSlider'
import './modules/someSideBar'
import './modules/newsletterModal'
import './modules/eventEmit'
import './modules/forms/newsletter'
import './modules/tooltips'

import './util/diviFixedHeaderFix'
import './util/datePicker'

jQuery(document).ready(function($){
    let onResize = function () {
        VARS.W = window.innerWidth
        VARS.H = window.innerWidth
    }

    VARS.scrollTop = $DOM.$window.scrollTop()
    let onScroll = function () {
        VARS.scrollTop = $DOM.$window.scrollTop()
    }

    let setEvents = function () {
        Events.on(ACTION.RESIZE, onResize)
        Events.on(ACTION.SCROLL, onScroll)
        
        //
        window.addEventListener('resize', () => { Events.emit(ACTION.RESIZE) })
        window.addEventListener('scroll', () => { Events.emit(ACTION.SCROLL) })
    }

    let init = function () {
        setEvents()

    }

    init()
    
    Events.emit(ACTION.DOM_READY)
})